/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EmailReplyIcon = ({
  className,
  style: styleFromProps,
  color = '#BFBFBF',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_10131_130707)">
        <path
          d="M5.73191 14.8206C5.65368 14.8208 5.57632 14.8043 5.50494 14.7723C5.43355 14.7403 5.36978 14.6935 5.31782 14.635L0.88968 9.65334C0.799713 9.55191 0.750031 9.42104 0.750031 9.28547C0.750031 9.14989 0.799713 9.01902 0.88968 8.9176L5.31782 3.93594C5.36613 3.8816 5.42467 3.8373 5.4901 3.80558C5.55553 3.77386 5.62656 3.75534 5.69915 3.75108C5.77173 3.74681 5.84445 3.75688 5.91314 3.78072C5.98183 3.80455 6.04516 3.84169 6.0995 3.89C6.15384 3.9383 6.19814 3.99684 6.22986 4.06227C6.26157 4.1277 6.28009 4.19873 6.28436 4.27132C6.28863 4.34391 6.27855 4.41662 6.25472 4.48531C6.23088 4.55401 6.19375 4.61733 6.14544 4.67167L2.04404 9.28547L6.14561 13.8993C6.21654 13.979 6.26291 14.0776 6.27912 14.1831C6.29533 14.2886 6.28069 14.3965 6.23697 14.4939C6.19326 14.5912 6.12232 14.6739 6.03271 14.7319C5.9431 14.7898 5.83864 14.8207 5.73191 14.8206Z"
          fill={color}
        />
        <path
          d="M8.75083 14.8206C8.67266 14.8206 8.59538 14.8041 8.52406 14.7721C8.45274 14.7401 8.389 14.6933 8.33702 14.6349L3.90888 9.65329C3.81891 9.55187 3.76923 9.421 3.76923 9.28542C3.76923 9.14985 3.81891 9.01898 3.90888 8.91756L8.33702 3.9359C8.41159 3.85196 8.50993 3.79268 8.61898 3.76593C8.72803 3.73919 8.84264 3.74624 8.94758 3.78615C9.05253 3.82606 9.14286 3.89694 9.20658 3.98939C9.2703 4.08184 9.3044 4.19149 9.30435 4.30377V6.55592C10.9341 6.74218 15.5947 7.83161 16.4946 14.1895C16.511 14.3056 16.4902 14.4238 16.4352 14.5273C16.3801 14.6307 16.2937 14.714 16.1882 14.7652C16.0828 14.8164 15.9639 14.8328 15.8485 14.8121C15.7332 14.7913 15.6274 14.7345 15.5464 14.6498C13.4622 12.4716 10.4968 12.1117 9.30435 12.0582V14.2671C9.30435 14.4139 9.24603 14.5547 9.14223 14.6585C9.03842 14.7623 8.89763 14.8206 8.75083 14.8206ZM5.06324 9.28542L8.19731 12.8113V11.4995C8.19735 11.3575 8.25195 11.221 8.34982 11.1181C8.44769 11.0152 8.58135 10.9539 8.72316 10.9468C10.9769 10.903 13.1907 11.546 15.0704 12.7903C13.5682 7.60827 8.9641 7.60998 8.76002 7.62487C8.61255 7.62254 8.47111 7.56597 8.36271 7.46596C8.31036 7.41443 8.26877 7.35301 8.24038 7.28527C8.21199 7.21752 8.19735 7.14481 8.19731 7.07135V5.75952L5.06324 9.28542Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10131_130707">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
